import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://elviynomaexlzzqbdufy.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVsdml5bm9tYWV4bHp6cWJkdWZ5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODczNTk1OTMsImV4cCI6MjEwMjkzNTU5M30.X3htnj3zuurPwUO0zTmeVDyVcIBKPmIahNtTZBISteM';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export async function signInWithGoogle() {
  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: 'https://bioscope-landing.onrender.com',
    },
  });
  if (error) console.error('Error en login:', error);
}

export async function getSession() {
  const { data } = await supabase.auth.getSession();
  return data.session;
}

export async function signInWithEmail(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) console.error('Error en login:', error);
  return { data, error };
}

export async function signUpWithEmail(email, password) {
  const { data, error } = await supabase.auth.signUp({ email, password });
  if (error) console.error('Error en registro:', error);
  return { data, error };
}